import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";
import { DevisCTA } from "@/components/DevisCTA";
import { Leaf } from "lucide-react";

const prestations = [
  { title: "Entretien régulier", text: "Suivi et entretien saisonnier de vos espaces verts." },
  { title: "Tonte", text: "Tonte des pelouses et gazons pour un extérieur net." },
  { title: "Taille", text: "Taille des haies, arbustes et végétaux." },
  { title: "Débroussaillage", text: "Débroussaillage des terrains et zones envahies." },
  { title: "Désherbage", text: "Désherbage des massifs, allées et surfaces." },
  { title: "Nettoyage", text: "Nettoyage et remise en propreté des espaces verts." },
  { title: "Remise en état", text: "Remise en état de jardins laissés à l'abandon." },
  { title: "Création et aménagement", text: "Création de massifs et aménagement paysager." },
  { title: "Restauration de jardins", text: "Restauration et rénovation de vos jardins." },
  { title: "Évacuation des déchets verts", text: "Ramassage et évacuation des déchets de coupe." },
];

export default function ParcsJardins() {
  return (
    <div data-testid="parcs-page">
      <Seo title="Parcs & Jardins — Entretien, création, restauration | Sandro Services 06 (06)" description="Tonte, taille, débroussaillage, désherbage, création de massifs et restauration de jardins dans les Alpes-Maritimes. Demandez votre devis." />
      <PageHero chapter="Parcs & Jardins" title="Parcs & Jardins" subtitle="Entretien, création et restauration de vos espaces verts.">
        <div className="mt-8 relative h-[300px] md:h-[420px] rounded-2xl overflow-hidden grain shadow-soft">
          <img src="https://images.unsplash.com/photo-1597201278257-3687be27d954?auto=format&fit=crop&w=1600&q=80" alt="Massifs et jardins entretenus" className="w-full h-full object-cover" />
        </div>
      </PageHero>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-14 md:py-20">
        <Reveal><h2 className="font-display text-3xl md:text-4xl text-forest">Nos prestations</h2></Reveal>
        <Stagger className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" stagger={0.06}>
          {prestations.map((p) => (
            <StaggerItem key={p.title} className="group bg-white border border-line rounded-2xl p-7 hover:shadow-soft hover:-translate-y-1 transition-all duration-300">
              <div className="w-11 h-11 rounded-full bg-sand-100 grid place-items-center text-olive group-hover:bg-olive group-hover:text-white transition-colors">
                <Leaf size={20} />
              </div>
              <h3 className="mt-5 font-display text-xl text-forest">{p.title}</h3>
              <p className="mt-2 text-sm text-ink-soft leading-relaxed">{p.text}</p>
            </StaggerItem>
          ))}
        </Stagger>
      </section>

      <DevisCTA />
    </div>
  );
}
